module.exports = __webpack_public_path__ + "components/rewards/treads-and-trails/static/logo-5321830afa7ab31caf62e65e46965e5b.webp";